var render = function () {var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;
return _c('v-main',[_vm._v(" 기능 상세보기 ")]);}
var staticRenderFns = []

export { render, staticRenderFns }